import { useCallback, useEffect, useState } from 'react';
import axios from '../../../axiosConfig';

/**
 * Fetches Finance Overview KPIs for the given period. Returns the
 * same shape as GET /api/finance/summary. Re-fetches whenever the
 * period changes.
 *
 * @param {string} period — '7d' | '30d' | '90d' | 'year' (default '7d')
 */
export default function useFinanceSummary(period = '7d') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSummary = useCallback(async (p) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get('/finance/summary', { params: { period: p } });
      setData(res.data);
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || 'Failed to load finance summary';
      setError(msg);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSummary(period);
  }, [period, fetchSummary]);

  return {
    data,
    loading,
    error,
    refetch: () => fetchSummary(period),
  };
}
